import { createTheme } from "@mui/material";

// Palette lifted from the Claude Design reference file's own <style> override
// (Setup de Propiedad.dc.html :root block) — this is the PassTrack-specific
// palette, distinct from the generic ActivaMente design-system tokens.
export const passtrackColors = {
  blue: "#0B57C4",
  blue900: "#0A2A6B",
  blue700: "#0B47A0",
  blue500: "#0B57C4",
  blue200: "#A9C4EE",
  cloud: "#E3EDFB",
  mist: "#F2F6FC",
  slate: "#A9B4C8",
  ink: "#0A2A6B",
  graphite: "#46536B",
  green: "#1E9E5A",
  green700: "#16713F",
  green200: "#A9DEBE",
  greenMist: "#E6F5EC",
  red: "#E4501F",
  borderSubtle: "#DEE6F2",
  borderDefault: "#C3D0E4",
  textMuted: "#6B7789",
} as const;

export const gradientBrand =
  "linear-gradient(100deg, #0A2A6B 0%, #0B57C4 58%, #1B76E8 100%)";

export const theme = createTheme({
  palette: {
    primary: { main: passtrackColors.blue, dark: passtrackColors.blue900 },
    secondary: { main: passtrackColors.green, dark: passtrackColors.green700 },
    error: { main: passtrackColors.red },
    text: {
      primary: passtrackColors.ink,
      secondary: passtrackColors.textMuted,
    },
    background: { default: passtrackColors.mist, paper: "#ffffff" },
  },
  shape: { borderRadius: 10 },
});
